import React from 'react'

import { maskString } from 'utils/functions'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'
import Colors from 'utils/Colors'
import { CONFLICT_TYPES_LIST, CONFLICTING_CNAE_TYPES_MESSAGES } from 'utils/constants/conflictingCnaeTypes'

import styles from '../styles'

const BuildCompanyData = (props) => {
  const { companyData } = props
  const classes = styles()

  const compareCompanies = (companyA, companyB) => {
    const equalCadastralSituation =
      companyA.cadastral_situation === companyB.cadastral_situation
    const equalCNPJ =
      companyA.cnpj[0].slice(0, 7) === companyB.cnpj[0].slice(0, 7)
    return equalCNPJ && equalCadastralSituation
  }

  const unifyCompaniesByCnpjAndStatus = (companiesList) => {
    const filteredCompanies = []

    companiesList.forEach((companyValues) => {
      const company = {
        cnpj: [companyValues.cnpj],
        name: companyValues.name,
        cadastral_situation: companyValues.cadastral_situation,
        conflict_classification: companyValues.conflict_classification,
        details: { data: { cnaes: companyValues.details?.data?.cnaes } },
        conflicts: companyValues.conflicts,
      }

      const index = filteredCompanies.findIndex((filteredCompany) => {
        return compareCompanies(filteredCompany, company)
      })

      if (index !== -1) {
        filteredCompanies[index].cnpj.push(company.cnpj[0])
      } else {
        filteredCompanies.push(company)
      }
    })

    return filteredCompanies
  }

  const sortByCadastralSituation = (companyA, companyB) => {
    if (
      companyA.cadastral_situation === 'ATIVA' &&
      companyB.cadastral_situation === 'ATIVA'
    )
      return 0
    if (
      companyA.cadastral_situation === 'ATIVA' &&
      companyB.cadastral_situation === 'BAIXADA'
    )
      return -1
    if (
      companyA.cadastral_situation === 'BAIXADA' &&
      companyB.cadastral_situation === 'ATIVA'
    )
      return 1
    return 0
  }

  const companies = unifyCompaniesByCnpjAndStatus(companyData.companies).sort(
    (a, b) => sortByCadastralSituation(a, b),
  )
  return companyData?.has_active_companies ? (
    <div className={classes.societaryParticipation}>
      <h3>Empresas com participação societária do candidato:</h3>
      <ul className={classes.companiesList}>
        {companies.map((company, index) => {
          const { conflicts, conflict_classification } = company
          const cnaes = company?.details?.data?.cnaes?.map((cnae) => {
            const code = maskString(cnae?.number?.toString() || '', 'cnae')
            return {
              code: code,
              ...cnae,
              conflicting_companies: CONFLICT_TYPES_LIST.includes(
                conflict_classification,
              )
                ? conflicts?.filter((conflict) => conflict.cnae === code)[0]
                  ?.conflicting_companies
                : null,
            }
          }) || []
          return (
            <li key={company.cnpj[0]}>
              <div>{`${index + 1}.`}</div>
              <div>
                <h4
                  className={
                    company.cadastral_situation !== 'ATIVA'
                      ? classes.dashedText
                      : null
                  }
                >
                  {company.name}
                </h4>
                <p>
                  <span>Situação cadastral: </span>
                  <span
                    style={{
                      color:
                        company.cadastral_situation === 'ATIVA'
                          ? Colors.green
                          : Colors.red,
                    }}
                  >
                    {company.cadastral_situation}
                  </span>
                </p>
                <p>
                  <span>CNPJ(s): </span>
                  {company.cnpj.map(
                    // eslint-disable-next-line no-shadow
                    (cnpj, index) =>
                      `${maskString(cnpj, 'cnpj')}${
                        index < company.cnpj.length - 1 ? ', ' : ''
                      }`,
                  )}
                </p>
                <p>
                  <span>
                    <span
                      style={{
                        color: CONFLICT_TYPES_LIST.includes(
                          conflict_classification,
                        )
                          ? Colors.red
                          : Colors.green,
                      }}
                    >
                      {CONFLICTING_CNAE_TYPES_MESSAGES[conflict_classification]}
                    </span>
                  </span>
                </p>
                {cnaes.length > 0 && (
                  <div>
                    <p>
                      <span>Atividades exercidas: </span>
                    </p>
                    <ul>
                      {cnaes.map((cnae) => (
                        <li key={cnae.number}>
                          <p>
                            <span>CNAE: </span>
                            {cnae.code}
                          </p>
                          <p>
                            <span>Descrição da atividade: </span>
                            {cnae.description}
                          </p>
                          {cnae.conflicting_companies && (
                            <div>
                              <p>
                                Empresas do grupo XP conflitantes com essa
                                atividade:
                              </p>
                              <ul className={classes.conflictCompaniesList}>
                                {addKeyToObjectsArray(
                                  cnae.conflicting_companies?.map(
                                    (c_company) => {
                                      return { name: c_company }
                                    },
                                  ),
                                )?.map((conflicting_company) => (
                                  <li key={conflicting_company.key}>
                                    {conflicting_company.name}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  ) : (
    <div className={classes.expansibleContent}>
      <span>Nenhum registro encontrado.</span>
    </div>
  )
}
export default BuildCompanyData
